import React, { useEffect } from 'react'

import { encerrarSessao, tokenValido } from './sessao'
import AUTH_TOKEN from './constants/authToken'

// https://github.com/reach/router/issues/100

const Redirect = props => {
  useEffect(() => {
    const redirect = () => {
      setTimeout(() => props.navigate(props.to, { replace: true }), 0)
    }
    redirect()
  }, [props])
  return null
}

/* Vencido conta como ausente: sem isso a rota liberava, tudo voltava 401
   e a tela ficava branca em vez de pedir login. */
const token = () => tokenValido()

export const OnlyAuthenticated = ({children, ...props}) => {
  if (token()) {
    return children.props.children({name: 'me'}, props)
  }

  /* Token vencido e token ausente levam os dois ao login, mas por motivos
     diferentes — e quem estava usando o sistema merece saber qual foi.

     Sem isto, quem ficou um dia sem entrar era jogado para o login sem uma
     linha de explicação, e a impressão é de que o sistema deslogou sozinho. O
     `encerrarSessao` ainda limpa o token vencido do localStorage: deixá-lo lá
     faria toda requisição seguinte sair com credencial morta. */
  const vencido = !!localStorage.getItem(AUTH_TOKEN)
  if (vencido) {
    encerrarSessao()
    return null
  }

  return (props.navigate ? <Redirect navigate={props.navigate} to='/login' /> : null)
}

export const OnlyUnauthenticated = ({children, ...props}) => {
  if (token()) {
    return (props.navigate ? <Redirect navigate={props.navigate} to='/' /> : null)
  }
  return children.props.children(props)
}











// const QueryMe = ({ children, shouldRenderChildren, ...props }) => {
//   // const { data, error, loading } = useQuery(ME)
  
//   // if (error) return `Erro! ${error.message}`
//   // if (!data || loading) return <CircularProgress color='hsla(199, 75%, 43%, 1)' />
  
//   const data = {
//     me: ''
//   }

//   if (data.me) {
//     if (shouldRenderChildren) return children.props.children(data.me, props)
//     return <Redirect navigate={props.navigate} to='/' />
//   }
//   return null
// }

// export const OnlyAuthenticated = ({ children, ...props }) => {
//   if (localStorage.getItem(AUTH_TOKEN))
//     return (<QueryMe shouldRenderChildren={true} children={children} navigate={props.navigate} />)
//   return <Redirect navigate={props.navigate} to='/login' />
// }

// export const OnlyUnauthenticated = ({ children, ...props }) => {
//   // if (localStorage.getItem(AUTH_TOKEN))
//     // return (<QueryMe shouldRenderChildren={false} children={children} navigate={props.navigate} />)
//   return children.props.children(props)
// }
